/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['agm-map[_ngcontent-%COMP%] {\n  height: 300px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvY3VzdG9tZXItZ3VpZGVzL2N1c3RvbWVyLWd1aWRlL2N1c3RvbWVyLWd1aWRlLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL2N1c3RvbWVyLWd1aWRlcy9jdXN0b21lci1ndWlkZS9jdXN0b21lci1ndWlkZS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/customer-guides/customer-guide/customer-guide.component.scss.shim.ngstyle.ts